import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgxPermissionsService, NgxPermissionsObject } from 'ngx-permissions';
import { ContactModel, ContactHistoryModel } from '@models/index';
import { ContactState } from '@enums/contactState.enum'
import { EntitiesEnum } from '@enums/entities.enum'
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact-table',
  templateUrl: './contact-table.component.html',
  styleUrls: ['./contact-table.component.sass'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ContactTableComponent implements OnInit {
  @Input() contacts: ContactModel[];
  @Input() contactHistory: ContactHistoryModel;
  @Input() showNoResults: boolean = false;
  @Input() deleteIcon: boolean;
  @Input() archiveIcon: boolean;
  @Input() entity: string;
  @Input() showMultiCampaign: boolean = false;
  @Output() onDelete = new EventEmitter();
  @Output() onArchive = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  @Output() onDetails = new EventEmitter();

  columnsToDisplay: string[] = [];
  columnsLabels: string[] = [];
  expandedElement: ContactModel;
  permissions: NgxPermissionsObject;

  constructor(
    private permissionsService: NgxPermissionsService
  ) { }

  ngOnInit() {
    this.permissions = this.permissionsService.getPermissions()
  }

  ngAfterContentInit() {
    // TODO: only show Campaign column if multi-campaign
    this.columnsToDisplay = this.entity === EntitiesEnum.Location
      ? this.showMultiCampaign == true
        ? ['status', 'name', 'email', 'phoneNumber', 'campaignNames', 'lastContact', 'created', 'actions']
        : ['status', 'name', 'email', 'phoneNumber', 'lastContact', 'created', 'actions']
      : ['status', 'name', 'email', 'phoneNumber', 'locationName', 'lastContact', 'created', 'actions'];
    this.columnsLabels = this.entity === EntitiesEnum.Location
      ? this.showMultiCampaign == true
        ? ['Status', 'Name', 'Email', 'Phone Number', 'Campaign', 'Last Contact', 'Created Date', 'Actions']
        : ['Status', 'Name', 'Email', 'Phone Number', 'Last Contact', 'Created Date', 'Actions']
      : ['Status', 'Name', 'Email', 'Phone Number', 'Location', 'Last Contact', 'Created Date', 'Actions']
    this.contacts = this.contacts.map((contact) => ({ ...contact, actions: true }))
    console.log(this.contacts);
    
    this.deleteIcon = true;
    this.archiveIcon = false;
  }

  deleteOrArchive(event: Event, contact: ContactModel) {
    event.stopPropagation();
    const typeAction = this.deleteIcon ? 'delete' : 'Archive'
    Swal.fire({
      title: `${typeAction} Contact`,
      text: `Are you sure you want to ${typeAction} contact ${contact.name} ${contact.lastName}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: `Yes, ${typeAction} contact!`,
      cancelButtonText: `Cancel`,
    }).then(result => {
      if (result.value) {
        this.deleteIcon
          ? this.onDelete.emit(contact)
          : this.onArchive.emit(contact)
      }
    })
  }

  contactStateBadgeColor(state: string): string {
    return state === ContactState.Active
      ? 'text-bg-primary'
      : state === ContactState.Completed
        ? 'text-bg-success'
        : 'text-bg-danger'
  }

  contactStateBadgeLabel(state: string): string {
    return state === ContactState.Active
      ? 'Active'
      : state === ContactState.Completed
        ? 'Complete'
        : 'In Queue'
  }

  didClickContact(_: Event, element: ContactModel) {
    if (element == this.expandedElement) {
      this.expandedElement = null;
      return;
    }

    if (this.permissions.viewContactHistory || this.permissions.viewBusinessContactHistory) {
      this.onDetails.emit(element);
      
      // emulate the old delay that resulted when the event bubbled from <td>'s onClick to <tr>'s
      setTimeout(() => {
        this.expandedElement = element;
      }, 1);
    }
  }

  deleteContact(event: Event, element: ContactModel) {
    event.stopPropagation();
    Swal.fire({
      title: 'Delete Contact',
      text: `Are you sure you want to delete contact ${element.name} ${element.lastName}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete contact!',
      cancelButtonText: 'Cancel',
    }).then(result => {
      if (result.value) {
        this.onDelete.emit(element)
      }
    })
  }
}
